































import { defineComponent } from '@nuxtjs/composition-api'
import { useAccount } from '~/composables/customer/useAccount'
import { useAuth } from '~/composables/useAuth'

export default defineComponent({
  name: 'AccountMenuList',

  props: {
    linkActiveClass: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { logout, logoutLoading } = useAuth()
    const { menu } = useAccount()

    return {
      menu,
      logoutLoading,

      logout,
    }
  },
})
